import { useState, useEffect } from 'react';
import Wrapper from '../assets/wrappers/Floors';
import { FormRow, FormRowSelect } from '../components';
import BusinessRow from '../components/BusinessRow';


import styled from 'styled-components';
const ContainerWrapper = styled.section`
  border: 1px solid var(--white-color);
  border-bottom: 5px solid var(--background-color);
  margin-top: 1rem;

  h2 {
    text-transform: none;
  }

  & > h5 {
    font-weight: 700;
    margin-bottom: 1.5rem;
  }

  .business {
    display: grid;
    grid-template-columns: 1fr;
    /* row-gap: 0.2rem; */
  }

  @media (min-width: 768px) {
    .business {
      grid-template-columns: repeat(2, 1fr);
      /* gap: 2rem; */
    }
  }

  @media (min-width: 1120px) {
    .business {
      grid-template-columns: repeat(4, 1fr);
      gap: 2rem;
    }
  }
`;

const AddBusiness = () => {
  
  const initialFormState = {
    name: '',
    logo: '',
    direction: 'ימינה',
  };

  const [formData, setFormData] = useState(initialFormState);

  const dummyData = [
    {
      id: 1,
      name: 'יניב אידל',
      logo: 'https://png.pngtree.com/png-vector/20211023/ourmid/pngtree-salon-logo-png-image_4004444.png',
      direction: 'ימינה',
    },
    {
      id: 2,
      name: 'צרפתי קירור חימום בעמ',
      logo: 'https://img.freepik.com/free-vector/bird-colorful-gradient-design-vector_343694-2506.jpg?w=740&t=st=1702973572~exp=1702974172~hmac=a231f9d907bcee60dc38c826d6a62522085cc1c3a24eb707c0f7dd008774b5bb',
      direction: 'שמאלה',
    },
    {
      id: 3,
      name: 'Floor 3',
      logo: 'https://img.freepik.com/free-vector/flat-design-ac-logo-design_23-2149482027.jpg?w=740&t=st=1702973591~exp=1702974191~hmac=08feb9cda4e10ee40abbcc3a4bad125694e9e9884af5a74fcff6c428f92518ee',
      direction: 'ישר',
    },
    {
      id: 4,
      name: 'א שחר',
      logo: 'https://img.freepik.com/free-vector/flat-design-ac-logo-design_23-2149482027.jpg?w=740&t=st=1702973591~exp=1702974191~hmac=08feb9cda4e10ee40abbcc3a4bad125694e9e9884af5a74fcff6c428f92518ee',
      direction: 'ימינה',
    },
    {
      id: 5,
      name: 'ענבל שילובים',
      logo: 'https://img.freepik.com/free-vector/flat-design-ac-logo-design_23-2149482027.jpg?w=740&t=st=1702973591~exp=1702974191~hmac=08feb9cda4e10ee40abbcc3a4bad125694e9e9884af5a74fcff6c428f92518ee',
      direction: 'ימינה',
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  useEffect(() => {
    console.log('Fetching data...');
    setTimeout(() => {
      console.log('Data fetched');
    }, 1000);
  }, []);

  return (
    <>
      <Wrapper>
        <form className='form'>
          <h3 className='form-title'>הוסף עסק</h3>
          <div className='form-center'>
            <FormRowSelect
              labelText='בחירת קומה'
              list={['ישר', 'שמאלה', 'ימינה']}
              name='direction'
              handleChange={handleChange}
              value={formData.direction}
            />

            <FormRow
              labelText='שם העסק'
              type='text'
              name='name'
              value={formData.name}
              handleChange={handleChange}
            />

            <FormRowSelect
              labelText='כיוון הליכה'
              list={['ישר', 'שמאלה', 'ימינה']}
              name='direction'
              handleChange={handleChange}
              value={formData.direction}
            />

            <FormRow
              labelText='נתיב ללוגו'
              type='text'
              name='logo'
              value={formData.logo}
              defaultValue={formData.logo}
              handleChange={handleChange}
            />

            <button type='submit' className='btn btn-primary'>
              טעינת לוגו
            </button>

            <div className='btn-container'>
              <button type='submit' className='btn btn-primary'>
                הוסף עסק
              </button>
              <button type='submit' className='btn btn-primary clear-btn'>
                נקה טופס
              </button>
            </div>
          </div>
        </form>
      </Wrapper>

      <ContainerWrapper>
        <div className='business'>
          {dummyData.map((business) => (
            <BusinessRow
              key={business.id}
              name={business.name}
              logo={business.logo}
              direction={business.direction}
            />
          ))}
        </div>
      </ContainerWrapper>
    </>
  );
};

export default AddBusiness;
